export default __webpack_public_path__ + "static/media/yellow_users.51062601.svg";